import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { formatLocalDateTime, toLocalTime } from 'shared-components/src/utils/formatDateTime';

// formatLocalDateTime in the cardholder's language: French reads the 24-hour clock with
// "h" (26 août 2026 à 15 h 42); any other locale gets the English form. Kept in the portal
// rather than shared-components, whose other consumers' jest setups don't transform the
// ESM date-fns/locale entry.
const formatLocalDateTimeForLocale = (time, locale) =>
  locale && locale.startsWith('fr')
    ? format(toLocalTime(time), 'd MMM yyyy \'à\' HH \'h\' mm', { locale: fr })
    : formatLocalDateTime(time);

export default formatLocalDateTimeForLocale;
